/* eslint-disable react/no-array-index-key */
import { useEffect, useRef } from 'react'
import { useTranslation } from 'react-i18next'
import Button from '@/components/Button/Button'
import styles from './GuestsList.module.scss'
import useTablesStore from '@/layouts/TablesList/hooks/useTablesStore'
import { useDishConfigurationStore } from '@/layouts/DishConfiguration/hooks/useDishConfigurationStore'

interface GuestsListProps {
  guestsNumber: number
  activeGuest?: number
  onGuestClick?: (guestNumber: number) => void
  showDelete?: boolean
}

function GuestsList(props: GuestsListProps) {
  const { guestsNumber, activeGuest, onGuestClick, showDelete = true } = props

  const listRef = useRef<HTMLDivElement>(null)

  useEffect(() => {
    if (listRef.current) {
      listRef.current.scrollLeft = listRef.current.scrollWidth
    }
  }, [guestsNumber])

  const { selectedGuestsNumber, setSelectedGuestsNumber } = useTablesStore()
  const { guestNumber, setGuestNumber } = useDishConfigurationStore()
  const { t } = useTranslation()

  const currentGuest = activeGuest ?? Number(guestNumber)

  const handleClick = (guestIndex: number) => {
    if (onGuestClick) {
      onGuestClick(guestIndex)
    } else {
      setGuestNumber(String(guestIndex))
    }
  }

  const handleDeleteSingleGuest = (guestNumber: number) => {
    if (Number(selectedGuestsNumber) > guestNumber) {
      setSelectedGuestsNumber(String(Number(selectedGuestsNumber) - 1))
    }
  }

  const getLabel = (index: number) => {
    const guestIndex = index + 1
    return t('COMMON.GUEST', { number: guestIndex })
  }

  return (
    <div className={styles.guestsListWrapper} ref={listRef}>
      {[...Array(guestsNumber)].map((_, index) => (
        <Button
          key={index}
          icon="las la-user-circle icon-large"
          label={getLabel(index)}
          variant="contained"
          color="primary"
          mobile
          onClick={() => handleClick(index + 1)}
          disabled={index === currentGuest - 1}
          showDeleteIcon={showDelete}
          onDelete={() => handleDeleteSingleGuest(index)}
        />
      ))}
    </div>
  )
}

export default GuestsList
